import { IBonusChart } from './bonus-chart.interface';
export interface IBonusDistribution {
  id:number;
  bonusCharts:IBonusChart[];
  code:string;
  name:string;
  isActive:boolean;
  status:string;
}
